import React from 'react';

import { Entry, Product, ServiceProductsType, ServiceEntriesType } from 'network/response/ICart';
import useExtendedWarranty from './hooks/useExtendedWarranty.hook';
import ExtendedWarrantyItem from './ExtendedWarrantyItem';

interface Props {
  productEntryNumber: Entry['entryNumber'];
  pid: Product['code'];
  quantity: number;
  serviceProducts: ServiceProductsType;
  serviceEntries?: ServiceEntriesType;
  intent?: string;
  offerId?: string;
}
const ExtendedWarranty: React.FC<Props> = ({ serviceEntries = [], quantity, ...rest }) => {
  const [entries] = useExtendedWarranty(serviceEntries, quantity);

  const warrantyItems = entries.map(({ entryNumber, quantity: qty, product: { code } }) => (
    <ExtendedWarrantyItem
      key={`filled-warranty-${rest.pid}-${entryNumber}`}
      entryNumber={entryNumber}
      quantity={qty}
      initialSelectedCode={code}
      {...rest}
    />
  ));

  for (let i = entries.length; i < quantity; i++) {
    warrantyItems.push(<ExtendedWarrantyItem key={`empty-warranty-${rest.pid}-${i}`} {...rest} />);
  }

  return <>{warrantyItems}</>;
};

export default ExtendedWarranty;
